import { render } from "./InstituteMap.vue?vue&type=template&id=b09db514"
import script from "./InstituteMap.vue?vue&type=script&lang=js"
export * from "./InstituteMap.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__